import React from 'react'

const React_Coding_Practice_2 = () => {
  return (
    <div>
      <h1>Coding Practice 2</h1>
    </div>
  )
}

export default React_Coding_Practice_2
